import { createModalContext } from 'modules/campaigns/lib/contexts';

export enum ModalType {
  None = 'None',
  CreateGoalModal = 'CreateGoalModal',
}

/**
 * TODO: make these types stricter
 */
export type ModalProps = Record<string, any>;

export const { ModalContext, ModalProvider, useModalContext } = createModalContext<
  ModalType,
  ModalProps
>();
